import { useCallback } from 'react';
import { RoiId } from '~/domain/changes/ids';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import { useRoiCommands } from '~/hooks/domain/useRoiCommands';
import useRoi from '~/hooks/structure-set/useRoi';

/**
 * Renames `roi`: through the projection's ROI commands when its branded
 * `roiId` is given, otherwise through the legacy domain-event path, for
 * example while the store is still initialising.
 */
export default function useRoiRename(
    roi: RoiReadModel,
    roiId?: RoiId
): (newName: string) => void {
    const { setName } = useRoi(roi);
    const { rename } = useRoiCommands();
    return useCallback(
        (newName: string) => {
            if (roiId !== undefined) {
                rename(roiId, newName);
            } else {
                setName(newName);
            }
        },
        [roiId, rename, setName]
    );
}
